;
define("cms_landing_page.tpl", function(){});

